import { useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Values from "@/components/Values";
import Wines from "@/components/Wines";
import Tasting from "@/components/Tasting";
import Gallery from "@/components/Gallery";
import Accommodation from "@/components/Accommodation";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function HomePage() {
    const [contactPrefill, setContactPrefill] = useState({ purpose: "general", message: "" });

    const scrollToContact = (purpose, message = "") => {
        setContactPrefill({ purpose, message });
        const el = document.getElementById("kontakt");
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <main data-testid="home-page" className="bg-cream text-ink relative">
            <div className="grain-overlay" aria-hidden="true"></div>
            <Navbar />
            <Hero />
            <About />
            <Values />
            <Wines onOrder={(name) => scrollToContact("wine", `Mám zájem o objednávku vína: ${name}.`)} />
            <Tasting onReserve={(name) => scrollToContact("tasting", `Rád(a) bych si rezervoval(a) degustaci: ${name}.`)} />
            <Gallery />
            <Accommodation onBook={(range) => scrollToContact("accommodation", `Mám zájem o ubytování v termínu ${range}.`)} />
            <Contact prefill={contactPrefill} />
            <Footer />
        </main>
    );
}
